import React , {useEffect, useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import { initializeApp } from 'firebase/app';
import { ref as sref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { getFirestore, collection, getDocs, addDoc } from 'firebase/firestore/lite';
import { getStorage } from "firebase/storage";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import { Link, Redirect, useParams } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

export default function NewUser() {

    const {id} = useParams();

    const [description, setdescription] = React.useState("");
    const [descriptionState, setdescriptionState] = React.useState("");
    const [material_cost, setmaterial_cost] = React.useState("");
    const [labor_cost, setlabor_cost] = React.useState("");
    const [redirctTo, setRedirctTo] = useState(false);
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [token_logged, settoken_logged] = React.useState("");
    const [tc, setTC] = React.useState(false);
    const [Errmessage, setErrmessage] = React.useState("");

    

    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };

    
    

  
  React.useEffect(() => {

      document.getElementById("test_id").innerHTML = "New Sign";

      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          console.log( res2.data );

        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }
    
  }, [  ]);

  const firebaseConfig = {
    apiKey: "AIzaSyCHuAWqJXbc6jXbPk-qJBg0GP7chcmPD-c",
    authDomain: "arcorapp.firebaseapp.com",
    projectId: "arcorapp",
    storageBucket: "arcorapp.appspot.com",
    messagingSenderId: "797370651875",
    appId: "1:797370651875:web:3da35938f7125735b121d6",
    measurementId: "G-SBWM9W1XGY"
  };

  const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);
    const storage = getStorage(app);
  

  const registerClick = async e => {
    let valid = 1;
    let image_url = "";
    e.preventDefault();

    if (description === "") {
        setdescriptionState("error");
        valid = 0;
    }

    if(description.length < 6){
        setdescriptionState("error");
        valid = 0;
        setErrmessage("Sing Name Characters Required");
        showNotification(true);
    }
    if(valid === 1){

      /*
      try {
        const files = document.getElementById('file1');        
        const file = files.files[0]
        if(file.size > 1024 * 1024){

        }
        if(file.type !== 'image/jpeg' && file.type !== 'image/png'){

        }
        let formData =  new FormData()
        formData.append('file', file)

        const res = await axios.post('/api/upload_sign', formData, {
            headers: {'content-type': 'multipart/form-data', Authorization: token_logged}
        })
        
        image_url = res.data;

      } catch (err) {
        //err.response.data.msg && 
        //setUser({...user, err: err.response.data.msg, success: ''})
      }  
      */
      try {
        const files = document.getElementById('file1');        
        const file = files.files[0]
        if(file){
          
          let new_name = Math.random().toString(36).substr(2, 9);
          new_name = new_name + file.name;
    
          const storageRef = sref(storage, new_name);
          const uploadTask = uploadBytesResumable(storageRef, file);
    
          const res1 = await uploadTask.on("state_changed",
            (snapshot) => {
              const progress =
                Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
              //setProgresspercent(progress);
            },
            (error) => {
              alert(error);
            },
            () => {
              getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                //setImgUrl(downloadURL)
                console.log(downloadURL);
                image_url = downloadURL;
                save_sign(description,downloadURL,material_cost,labor_cost);
                
              });
            }
          );  
        }else{
          save_sign(description,"",material_cost,labor_cost);
        }
      } catch (err) {

      }

        
    }
    



  };

  async function save_sign(description,image_url,material_cost,labor_cost) {
    try {
        const res = await axios.post('/codeset/register_sign', {
            description, image_url, material_cost, labor_cost, codeset_id : id
        })
        console.log(res.data.msg);


        setRedirctTo_new_user(true);
        //setUser({...user, err: '', success: res.data.msg})
    } catch (err) {
        setErrmessage(err.response.data.msg);
        showNotification(true);
        //err.response.data.msg && 
        //setUser({...user, err: err.response.data.msg, success: ''})
    }     
  }

  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to={'/admin/signs/'+ id}  />
  }


  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      <GridContainer>
          
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
                <Link to={'/admin/signs/'+ id}>
                  <Button color="rose" className={classes.right}>
                      Back to All Cost Items
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Cost Item
                </Button>
            </div>
          <Card>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={descriptionState === "success"}
                            error={descriptionState === "error"}
                            labelText="Cost Item Name"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    if (verifyLength(event.target.value, 1)) {
                                        setdescriptionState("success");
                                    } else {
                                        setdescriptionState("error");
                                    }
                                    setdescription(event.target.value);
                                },
                            type: "text",
                            autoComplete: "off"
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={4} md={4}>
                    <legend>Image  (.PNG Recommended)</legend>
                    <ImageUpload
                        addButtonProps={{
                        color: "rose",
                        round: true
                        }}
                        changeButtonProps={{
                        color: "rose",
                        round: true
                        }}
                        removeButtonProps={{
                        color: "danger",
                        round: true
                        }}
                    />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={2}>
                                Item Cost
                                <CustomInput
                                    id={"material_cost" }
                                    formControlProps={{
                                    fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: event => {
                                            if (verifyLength(event.target.value, 1)) {
                                                //setdescriptionState("success");
                                            } else {
                                                //setdescriptionState("error");
                                            }
                                            setmaterial_cost(event.target.value);
                                        },
                                      type: "text",
                                      autoComplete: "off",
                                      placeholder: "$0.00"
                                    }}
                                />
                            </GridItem>    
                            <GridItem xs={12} sm={12} md={2}>
                                Labor Cost
                                <CustomInput
                                    id={"labor_cost"  }
                                    formControlProps={{
                                    fullWidth: true
                                    }}
                                    inputProps={{
                                      onChange: event => {
                                          if (verifyLength(event.target.value, 1)) {
                                              //setdescriptionState("success");
                                          } else {
                                              //setdescriptionState("error");
                                          }
                                          setlabor_cost(event.target.value);
                                      },
                                    type: "text",
                                    autoComplete: "off",
                                    placeholder: "$0.00"
                                  }}
                                />
                            </GridItem> 
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            
            </CardBody>
          </Card>
          <div className={classes.right}>
                <Link to={'/admin/signs/'+ id}>
                  <Button color="rose" className={classes.right}>
                      Back to All Cost Items
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Cost Item
                </Button>
            </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
